@if (notificationType === notificationTypeEnum.SUCCESS) {
  <div class="row justify-start align-center">
    <mat-icon class="notification-icon margin-right-small">check_circle</mat-icon>
    <div class="notification-indicator-color" style="padding-left: 8px;">{{ message }}</div>
  </div>
}

@if (notificationType === notificationTypeEnum.ERROR) {
  <div class="row justify-space-between center">
    <div class="row justify-start align-center">
      <mat-icon (dblclick)="showTrace = !showTrace" class="notification-icon margin-right-small">cancel</mat-icon>
      <div class="notification-indicator-color" style="padding-left: 8px;">{{ message }}</div>
      @if (showTrace && trace.length > 0) {
        <div style="margin-top: 5px"><p style="word-wrap: break-word;inline-size: 350px">{{ trace }}
          <p></div>
      }
    </div>
    <mat-icon (click)="dismiss()" class="notification-dismiss">close</mat-icon>
  </div>
}

@if (notificationType === notificationTypeEnum.ACTION) {
  <div class="row justify-space-between center align-center">
    <div class="row justify-start align-center">
      <!--      <mat-icon (dblclick)="showTrace = !showTrace" class="notification-icon margin-right-small">check_circle</mat-icon>-->
      <div class="notification-indicator-color">{{ message }}</div>
      @if (showTrace && trace.length > 0) {
        <div style="margin-top: 5px"><p style="word-wrap: break-word;inline-size: 350px">{{ trace }}
          <p></div>
      }
    </div>
    <button mat-button (click)="dismissWithAction()" color="primary">{{ action }}</button>
    <mat-icon (click)="dismiss()" class="notification-dismiss">close</mat-icon>
  </div>
}

@if (notificationType === notificationTypeEnum.INFO) {
  <div class="row start center">
    <mat-icon class="notification-icon margin-right-small">info</mat-icon>
    <div style="padding-left: 8px; inline-size: 350px">{{ message }}</div>
  </div>
}

@if (notificationType === notificationTypeEnum.WARNING) {
  <div class="row start center">
    <mat-icon class="notification-icon margin-right-small">error</mat-icon>
    <div class="notification-indicator-color" style="padding-left: 8px;">{{ message }}</div>
  </div>
}
